<script lang="ts">
	import { TextRowSelector } from "misc-ui"
	import { ShowLibraryController, type ShowLibraryViewOption } from "../ShowLibraryController"
	import { DataHandlerScene, Device } from "luxedo-data"
	import ProjectTags from "../../../reusable/tags/ProjectTags.svelte"
	import { SearchBarInput } from "misc-ui"
	import ShowLibraryFilter from "./ShowLibraryFilter.svelte"
	import { onMount } from "svelte"
	import { openNewSceneOverlay } from "../../../reusable/overlays"
	import { Responsive } from "responsive"

	interface Props {
		selectedTags?: Array<number>
		searchInput?: string
	}

	let { selectedTags = $bindable([]), searchInput = $bindable(undefined) }: Props = $props()

	let selectedOption: ShowLibraryViewOption = $state("Scenes")
	let viewType: ShowLibraryViewOption = $state("Scenes")
	let isEditingLightshow: boolean = $state(false)

	let isSearchOpen: boolean = $state(false)
	let userHasNoScenes: boolean = $state(false)

	let selectedDevice: Device
	let isMobile = $derived(Responsive.isMobile)

	ShowLibraryController.subscribe((ctx) => {
		isEditingLightshow = ctx.isEditingLightshow
		selectedDevice = ctx.deviceFilter
	})

	function onSearch(searchValue: string) {
		searchInput = searchValue
	}

	function onCancelSearch() {
		searchInput = undefined
	}

	function createScene() {
		openNewSceneOverlay({ device: selectedDevice })
	}

	function handleCreateNew() {
		console.log("view type", viewType)
		if (viewType === "Scenes") createScene()
		else ShowLibraryController.LightshowEditor.createLightshow()
	}

	onMount(() => {
		if (DataHandlerScene.getMany().length === 0) userHasNoScenes = true
	})

	function changeView(newView: string) {
		if (newView === viewType) return
		viewType = newView as ShowLibraryViewOption
		ShowLibraryController.changeView(newView as ShowLibraryViewOption)
	}
</script>

<div id="library-options" class:isMobile>
	<div class="header">
		{#if isEditingLightshow}
			<h3>Select Scenes</h3>
		{:else if userHasNoScenes}
			<h3>Scenes</h3>
			<button
				class="create-button outline-button"
				onclick={() =>
					viewType === "Scenes"
						? createScene()
						: ShowLibraryController.LightshowEditor.createLightshow()}
				title="Create New Scene"
			>
				Create Scene
			</button>
		{:else}
			<TextRowSelector
				options={["Scenes", "Lightshows"]}
				fontSize="var(--h1)"
				bind:selectedOption
				onChange={changeView}
			/>
			<button
				class="create-button outline-button"
				onclick={handleCreateNew}
				title="Create New {viewType.substring(0, viewType.length - 1)}"
			>
				Create {viewType.substring(0, viewType.length - 1)}
			</button>
		{/if}
	</div>

	<div id="library-filter-actions">
		{#if !isMobile || !isSearchOpen}
			<ProjectTags bind:selectedTags isLibraryContext={true} alignLeft={isMobile} />
			<ShowLibraryFilter />
		{/if}
		<SearchBarInput {onSearch} onClose={onCancelSearch} bind:isOpen={isSearchOpen} />
	</div>
</div>

<style>
	h3 {
		font-size: var(--h1);
		margin: 0;
		color: var(--color-text-light);
	}

	#library-options {
		display: flex;
		flex-direction: row;
		padding: 1rem;
		background-color: var(--color-bg-dark);
		border-radius: var(--br);
		align-items: center;
		white-space: nowrap;

		/* overflow: hidden; */
		position: sticky;
		top: 0;
		z-index: 10;
		box-shadow: var(--shadow-small);
	}

	#library-options.isMobile {
		flex-direction: column;
		position: relative;
		border-radius: 0;
	}

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.isMobile .header,
	.isMobile #library-filter-actions {
		width: 100%;
	}

	.isMobile .header h3,
	.isMobile .header :global(.text-row-selector button) {
		line-height: 1.3;
	}

	.create-button {
		margin-left: 1rem;
		padding: 0rem 1rem;
	}

	#library-filter-actions {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		flex-grow: 1;
		overflow: hidden;
	}

	.isMobile #library-filter-actions {
		margin-top: 0.5rem;
		gap: 0.5rem;
	}

	.isMobile .create-button {
		font-size: var(--h3);
	}
</style>
